const NewFutureIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9.66667H18M6 9.66667V16.5113C6 17.3825 6 17.8178 6.16349 18.1506C6.3073 18.4433 6.5366 18.6815 6.81885 18.8306C7.1394 19 7.55925 19 8.39768 19H15.6027C16.4411 19 16.8604 19 17.1809 18.8306C17.4632 18.6815 17.6929 18.4433 17.8367 18.1506C18 17.8182 18 17.3834 18 16.5139V9.66667M6 9.66667V9.0446C6 8.1734 6 7.73748 6.16349 7.40473C6.3073 7.11203 6.5366 6.87424 6.81885 6.7251C7.13972 6.55556 7.56007 6.55556 8.40015 6.55556H9M18 9.66667V9.04204C18 8.17255 18 7.73716 17.8367 7.40473C17.6929 7.11203 17.4632 6.87424 17.1809 6.7251C16.86 6.55556 16.4402 6.55556 15.6001 6.55556H15M9 6.55556H15M9 6.55556V5M15 6.55556V5M13.875 14.3333H12M12 14.3333H10.125M12 14.3333V12.3889M12 14.3333V16.2778"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewFutureIcon;
